import styled from 'styled-components';

import { ColorNames, colors } from 'utils/styles/theme';

interface ContainerProps {
  textColor?: ColorNames | string;
}

export const Wrapper = styled.div``;

export const Container = styled.div<ContainerProps>`
  & > * {
    ${({ textColor }) =>
      textColor &&
      `color: ${
        colors[textColor] ?? textColor
      } !important`}; // bugging while rendering, "important" fix it
  }
`;
